import React, { useMemo } from 'react';
import { NavLink } from 'react-router-dom';
import {
  HomeOutlined,
  WalletOutlined,
  CreditCardOutlined,
  SwapOutlined,
  RocketOutlined,
  AppstoreOutlined,
} from '@ant-design/icons';
import { useAuth } from '../../contexts/AuthContext';
import './MobileBottomNav.css';

/**
 * Barra inferior PWA — destinos diários; "Mais" abre o drawer da sidebar.
 */
const MobileBottomNav = ({ onOpenMore }) => {
  const { temModuloFinanceiro, temModuloMilhas } = useAuth();

  const items = useMemo(() => {
    const tabs = [];

    if (temModuloFinanceiro || temModuloMilhas) {
      tabs.push({
        key: 'desempenho',
        to: '/meu-desempenho',
        label: 'Início',
        icon: <HomeOutlined />,
        end: true,
      });
    }

    if (temModuloFinanceiro && temModuloMilhas) {
      tabs.push(
        { key: 'contas', to: '/contas', label: 'Contas', icon: <WalletOutlined /> },
        { key: 'transacoes', to: '/transacoes', label: 'Transações', icon: <SwapOutlined /> },
        { key: 'milhas', to: '/milhas/extrato', label: 'Milhas', icon: <RocketOutlined /> },
      );
    } else if (temModuloFinanceiro) {
      tabs.push(
        { key: 'contas', to: '/contas', label: 'Contas', icon: <WalletOutlined /> },
        { key: 'cartoes', to: '/cartoes', label: 'Cartões', icon: <CreditCardOutlined /> },
        { key: 'transacoes', to: '/transacoes', label: 'Transações', icon: <SwapOutlined /> },
      );
    } else if (temModuloMilhas) {
      tabs.push({
        key: 'milhas',
        to: '/milhas/extrato',
        label: 'Extrato',
        icon: <SwapOutlined />,
      });
    }

    tabs.push({
      key: 'mais',
      label: 'Mais',
      icon: <AppstoreOutlined />,
      onClick: onOpenMore,
    });

    return tabs;
  }, [temModuloFinanceiro, temModuloMilhas, onOpenMore]);

  if (items.length <= 1) return null;

  return (
    <nav className="mobile-bottom-nav" aria-label="Navegação principal">
      {items.map((item) => {
        if (item.onClick) {
          return (
            <button
              key={item.key}
              type="button"
              className="mobile-bottom-nav__item"
              onClick={item.onClick}
              aria-label={item.label}
            >
              <span className="mobile-bottom-nav__icon">{item.icon}</span>
              <span className="mobile-bottom-nav__label">{item.label}</span>
            </button>
          );
        }

        return (
          <NavLink
            key={item.key}
            to={item.to}
            end={item.end}
            className={({ isActive }) =>
              `mobile-bottom-nav__item${isActive ? ' mobile-bottom-nav__item--active' : ''}`
            }
          >
            <span className="mobile-bottom-nav__icon">{item.icon}</span>
            <span className="mobile-bottom-nav__label">{item.label}</span>
          </NavLink>
        );
      })}
    </nav>
  );
};

export default MobileBottomNav;
